module.exports = __webpack_public_path__ + "img/f-07.519cfa4e.jpg";